@if (details(); as details) {
  <div class="card">
    <div class="card-body">
      <div class="row">
        @if (details.trackingNumber || directionKey() || carrierCombined()) {
          <div class="col-12 col-md-6 col-lg-3 border-md-end">
            <div class="d-flex flex-column">
              <h4>{{ 'pages.transport.detail-page.details.headline' | translate }}</h4>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.details.tracking-number' | translate"
                [data]="details.trackingNumber"
              ></myarvato-data-field>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.details.shipment-direction' | translate"
                [data]="directionKey() | translate"
              ></myarvato-data-field>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.details.carrier-service-category' | translate"
                [data]="carrierCombined()"
              ></myarvato-data-field>
            </div>
          </div>
        }

        @if (
          details.eventInfo.deliverySlot ||
          details.eventInfo.mustArriveBy ||
          details.eventInfo.eta ||
          details.eventInfo.deliveryDate ||
          details.timestampFirstDeliveryAttempt
        ) {
          <div class="col-12 col-md-6 col-lg-3 border-lg-end">
            <div class="d-flex flex-column ml-md--16">
              <h4>{{ 'pages.transport.detail-page.dates.headline' | translate }}</h4>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.dates.delivery-slot' | translate"
                [data]="details.eventInfo.deliverySlot | dayjs: 'L' : false : false"
              ></myarvato-data-field>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.dates.must-arrive-by' | translate"
                [data]="details.eventInfo.mustArriveBy | dayjs: 'L' : false : false"
              ></myarvato-data-field>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.dates.eta' | translate"
                [data]="details.eventInfo.eta | dayjs: 'L LT' : true"
              ></myarvato-data-field>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.dates.delivery-date' | translate"
                [data]="details.eventInfo.deliveryDate | dayjs: 'L LT' : true"
              ></myarvato-data-field>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.dates.first-delivery-attempt' | translate"
                [data]="details.timestampFirstDeliveryAttempt | dayjs: 'L LT' : true"
              ></myarvato-data-field>
            </div>
          </div>
        }

        @if (progressCombined() || details.exceptionResolutionStatus) {
          <div class="col-12 col-md-6 col-lg-3 border-md-end">
            <div class="d-flex flex-column ml-lg--16">
              <h4>{{ 'pages.transport.detail-page.status.headline' | translate }}</h4>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.status.progress' | translate"
                [data]="progressCombined()"
              ></myarvato-data-field>

              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.status.exception-resolution-status' | translate"
                [data]="details.exceptionResolutionStatus"
              ></myarvato-data-field>
            </div>
          </div>
        }

        @if (details.recipient.name1 || details.recipient.name2 || details.recipient.name3 || details.recipient) {
          <div class="col-12 col-md-6 col-lg-3">
            <div class="d-flex flex-column ml-md--16">
              <h4>{{ 'pages.transport.detail-page.recipient.headline' | translate }}</h4>

              @if (details.recipient.name1) {
                <myarvato-data-field
                  styleClass="pb--8"
                  [label]="'pages.transport.detail-page.recipient.name' | translate"
                  [data]="details.recipient.name1"
                ></myarvato-data-field>
              }

              @if (details.recipient.name2) {
                <myarvato-data-field
                  styleClass="pb--8"
                  [label]="'pages.transport.detail-page.recipient.name2' | translate"
                  [data]="details.recipient.name2"
                ></myarvato-data-field>
              }

              @if (details.recipient.name3) {
                <myarvato-data-field
                  styleClass="pb--8"
                  [label]="'pages.transport.detail-page.recipient.name3' | translate"
                  [data]="details.recipient.name3"
                ></myarvato-data-field>
              }

              <myarvato-address-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.recipient.address' | translate"
                [city]="details.recipient.zipCode + ' ' + details.recipient.city"
                [countryCode]="details.recipient.country"
                [street]="details.recipient.street"
              ></myarvato-address-field>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
